import {Button} from 'react-bootstrap'
import styled from 'styled-components';
import breakpoints from '../../config/Breakpoints';
import useReadingSessionStore from '../../routes/book/reading/useReadingSessionStore';
import useLoginStore from '../../routes/login/useLoginStore';

const TimerFloatingButton = () => {
    const {timerInSeconds, isShowingTimer, openTimerModal} = useReadingSessionStore()
    const isLoggedIn = useLoginStore((state) => state.isLoggedIn)

    return (
        <>
            {isLoggedIn() && isShowingTimer() && (
                // @ts-ignore
                <ButtonContainer variant='book' onClick={openTimerModal}>
                    <h6 className='mt-1 mb-0 text-white'>{`${Math.floor((timerInSeconds / 60 / 60) % (60 * 60))}H `}</h6>
                    <h6 className='mt-0 text-white' style={{whiteSpace: 'nowrap'}}>
                        {Math.floor(timerInSeconds / 60) % 60}M {`${timerInSeconds % 60}S`}
                    </h6>
                </ButtonContainer>
            )}
        </>
    )
}

const ButtonContainer = styled(Button)`
    position: fixed;
    
    border-radius: 10px;
    z-index: 10;
    
    width: 90px;
    height: 60px;
    right: 20px;
    bottom: 90px;
    
    @media screen and (min-width: ${breakpoints.md}) {
        right: 30px;
        bottom: 100px;
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        right: 60px;
        bottom: 130px;
    }
`;


export default TimerFloatingButton
